"use strict";
/* eslint-disable camelcase */
Object.defineProperty(exports, "__esModule", { value: true });
class Crop {
    constructor(cropObj) {
        this.id = cropObj.id || 0;
        this.name = cropObj.name || '';
        this.botanical_name = cropObj.botanical_name || '';
        this.approved = cropObj.approved || true;
        this.intel_active = cropObj.intel_active || true;
        this.activated_at = cropObj.activated_at || '';
        this.created_at = cropObj.created_at || '';
        this.updated_at = cropObj.updated_at || '';
        this.logo_name = cropObj.logo_name || 'general';
        this.is_woody = cropObj.is_woody || false;
    }
}
exports.default = Crop;
